// 错误码文件
export const errorCodes = [{
		code: '200',
		message: {
			en: 'Operation successful',
			zh: '操作成功'
		},
		solution: {
			en: 'No action needed',
			zh: '无需操作'
		}
	},
	{
		code: '500',
		message: {
			en: 'Operation failed',
			zh: '操作失败'
		},
		solution: {
			en: 'Please contact support',
			zh: '请联系支持'
		}
	},
	{
		code: '400',
		message: {
			en: 'Parameters are incorrect',
			zh: '参数不正确'
		},
		solution: {
			en: 'Please check your parameters',
			zh: '请检查您的参数'
		}
	},
	{
		code: '400',
		message: {
			en: 'Parameter validation failed',
			zh: '参数检验失败'
		},
		solution: {
			en: 'Please validate your input',
			zh: '请验证您的输入'
		}
	},
	{
		code: '401',
		message: {
			en: 'Not logged in or token expired, please log in!',
			zh: '未登录或token过期，请登录!'
		},
		solution: {
			en: 'Please log in again',
			zh: '请重新登录'
		}
	},
	{
		code: '403',
		message: {
			en: 'No related permissions',
			zh: '没有相关权限'
		},
		solution: {
			en: 'Please contact your administrator',
			zh: '请联系管理员'
		}
	},
	{
		code: '404',
		message: {
			en: 'No related data found',
			zh: '没有找到相关数据'
		},
		solution: {
			en: 'Please check your request',
			zh: '请检查您的请求'
		}
	},
	{
		code: '500',
		message: {
			en: 'System exception',
			zh: '系统异常'
		},
		solution: {
			en: 'Please try again later',
			zh: '请稍后再试'
		}
	}
];